import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const SecurityStyles = styled(OnboardingPage)`
  ion-content {
    position: relative;
  }

  .animation {
    transform: scale(1.3);
    position: absolute;
    top: -10%;
    left: 0;
    bottom: -25%;
    right: 0;
  }

  .securityPolicy {
    text-align: center;
    width: 100%;
    position: absolute;
    padding: 0 16px;
    margin: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 0);
    right: 0;
  }

  .disclaimer {
    font-size: 11px;
    line-height: 13px;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
    max-width: 330px;
    padding: 0 10px;
  }

  .link {
    height: unset !important;
    padding: unset;
    border: unset;
    --background: unset !important;
    font-size: 0.9em !important;
    min-height: 0.9em;
    text-decoration: underline;

    &::part(native) {
      color: rgba(128, 62, 255);
      --ripple-color: rgba(128, 62, 255);
      --ripple-color: transparent;
      --padding-bottom: 0.7em;
      --padding-end: 0.1em;
      --padding-start: 0.3em;
      --padding-top: 0.1em;

      &::after {
        content: none;
      }
    }
  }
`;
